<template>
  <div id="Shop">
    <Header :From="'Shop'" :CartItems="total_cart_items" />
    <CContainer
      class="d-flex align-items-center"
      style="width:100vw; height:90vh; position: relative"
    >
      <div class="load" v-if="items.length == 0">
        <CIcon name="cil-cart" height="48" />
      </div>
      <VueTinder
        key-name="id"
        :queue.sync="items"
        :offset-y="-10"
        @submit="onSubmit"
        ref="tinder"
      >
        <template slot-scope="scope">
          <div
            v-if="scope.data.title != 'Voucher'"
            class="pic"
            :style="
              'background-image: url(' +
                scope.data.photoSlide[scope.data.slideCounter] +
                ')'
            "
          >
            <div class="filter-image">
              <div class="slide-show" @click="slideShow(scope.data)"></div>
              <!-- <div class="diagonal badge red">
              -{{ scope.data.sale }}%
            </div> -->
              <div class="slider">
                <div
                  v-for="(slide, index) in scope.data.photoSlide"
                  :key="slide"
                >
                  <div
                    :class="
                      scope.data.slideCounter == index
                        ? 'info-step-active'
                        : 'info-step'
                    "
                  ></div>
                </div>
              </div>
              <div class="tag" v-if="scope.data.seller_verified">
                <img
                  style="width: 15px;margin-bottom: 3px;margin-right: 5px;"
                  src="/icons_2/verified.png"
                  alt=""
                />{{ "Verified Seller" }}
              </div>
              <div class="card-text-box">
                <div class="mb-4">
                  <div class="mb-1" style="display: flex; width: 100%;">
                    <div class="ml-1 product-title">
                      {{ scope.data.title }}
                    </div>
                    <strong v-if="scope.data.exclusive" class="exclusive">
                      <font-awesome-icon
                        style="color: #23b8ff;margin-top: 3px;"
                        class="faIcon"
                        icon="star"
                      />
                      Exclusive
                    </strong>
                  </div>
                  <!-- <strong
                    v-if="scope.data.exclusive"
                    class="mb-0"
                    style="position: fixed; right: 0; margin-right: 70px; color: #23b8ff;background-color: #00000084;padding: 3px;border-radius: 6px;"
                  >
                    <font-awesome-icon
                      style="color: #23b8ff;"
                      class="faIcon"
                      icon="star"
                    />
                    Exclusive
                  </strong> -->
                  <div class="mb-2" style="display: flex;">
                    <p v-if="scope.data.statusLabel" class="mb-0 text-status">
                      <img
                        src="/icons_2/ok-hand.svg"
                        style="width: 16px; margin-bottom: 3px;"
                        alt=""
                      />
                      {{ scope.data.statusLabel.label }}
                    </p>

                    <p class="mb-0 text-status" v-if="scope.data.location">
                      <img
                        src="/icons_2/location-dot.svg"
                        style="width: 13px; margin-bottom: 3px"
                        alt=""
                      />
                      {{ scope.data.location }}
                    </p>
                  </div>
                  <div style="display: flex; width: 100%;">
                    <div v-if="scope.data.sale" style="display: flex;">
                      <p class="mb-0 text-price">
                        {{ scope.data.promo_price }} DT
                      </p>
                    </div>
                    <div v-else>
                      <p class="mb-0 text-price">
                        <b
                          >{{ scope.data.price }}
                          DT
                        </b>
                      </p>
                    </div>
                    <button
                      class="show-hidden-btn"
                      @click="
                        show_hidden_data = !show_hidden_data;
                        toggleHidden(scope.data.id);
                      "
                    >
                      <font-awesome-icon
                        class="faIcon"
                        icon="chevron-right"
                        v-if="!show_hidden_data"
                      />
                      <font-awesome-icon
                        class="faIcon"
                        icon="chevron-down"
                        v-else
                      />
                      {{ $t("Shop.SeeMore") }}
                    </button>
                  </div>
                </div>
                <div :class="'hidden hidden-' + scope.data.id">
                  <hr />
                  <span style="color: var(--primary-dark);"
                    ><b>{{ $t("Shop.Details") }}:</b></span
                  >
                  <div>
                    {{ scope.data.type }} {{ $t("Shop.For") }}
                    <span v-if="scope.data.gender == 'M'">
                      {{ $t("Shop.Men") }}</span
                    >
                    <span v-else-if="scope.data.gender == 'F'">
                      {{ $t("Shop.Women") }}</span
                    >
                    <span v-else> {{ $t("Shop.Men&Women") }}</span>
                  </div>
                  <div v-if="scope.data.reference">
                    <b>{{ $t("Shop.Reference") }}: </b
                    >{{ scope.data.reference }}
                  </div>
                  <div v-if="scope.data.brand">
                    <b>{{ $t("Shop.Brand") }}: </b>{{ scope.data.brand }}
                  </div>
                  <div style="display: flex;">
                  <div v-if="scope.data.size" class="pl-0">
                    <b>{{ $t("Shop.Size") }}: </b>{{ scope.data.size }}
                  </div>
                  <div v-if="scope.data.color" class="ml-4">
                    <b>{{ $t("Shop.Color") }}: </b>{{ scope.data.color }}
                  </div>
                  </div>
                  <div v-if="scope.data.sale" style="display: flex;">
                    <b>{{ $t("Shop.Price") }} :</b>
                    <p class="ml-1 mb-0">
                      <del>{{ scope.data.price }} DT </del>
                    </p>
                    <p class="ml-1 mb-0" style="color: var(--primary);">
                      {{ scope.data.promo_price }} DT
                    </p>
                  </div>
                  <div v-else>
                    <p>
                      <b
                        >{{ scope.data.price }}
                        DT
                      </b>
                    </p>
                  </div>
                  <div v-if="scope.data.sale" style="color: var(--primary);">
                    <b>{{ $t("Shop.Discount") }}: </b>-{{ scope.data.sale }}%
                  </div>

                  <button
                    class="button-pink show-images-div"
                    @click="decide('details')"
                  >
                    <font-awesome-icon class="faIcon" icon="eye" />
                    {{ $t("Shop.SeePhotos") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div
            v-else
            class="pic"
            :style="'background-image: url(/VOUCHER.jpg)'"
          ></div>
        </template>
        <img class="like-pointer" slot="like" src="/buttons/like-txt.png" />
        <img class="nope-pointer" slot="nope" src="/buttons/nope-txt.png" />
        <img class="super-pointer" slot="super" src="/buttons/super-txt2.png" />
      </VueTinder>
      <vue-gallery-slideshow
        class="vh-100 vw-100"
        :images="images"
        :index="index"
        @close="index = null"
      ></vue-gallery-slideshow>
      <div class="btns" v-if="items.length > 0">
        <img src="/buttons/rewind.png" @click="decide('rewind')" />
        <img src="/buttons/nope.png" @click="decide('nope')" />
        <img src="/buttons/super-like.png" @click="decide('super')" />
        <img src="/buttons/like.png" @click="decide('like')" />
        <img
          src="/buttons/images.png"
          @click="decide('details')"
          style="background: #fff;"
        />
      </div>
    </CContainer>
  </div>
</template>

<script>
import VueTinder from "vue-tinder";
import source from "../../bing";
import { shopService } from "../../_services/shop.service";
import VueGallerySlideshow from "vue-gallery-slideshow";
import Header from "../../components/Header.vue";
import $ from "jquery";

export default {
  name: "Shop",
  components: {
    VueTinder,
    VueGallerySlideshow,
    Header,
  },
  data: () => ({
    queue: [],
    items: [],
    images: [""],
    history: [],
    status: [
      { value: "1", label: "New with tag" },
      { value: "2", label: "New without tag" },
      { value: "3", label: "Very good state" },
      { value: "4", label: "Good condition" },
      { value: "5", label: "Satisfying" },
    ],
    offset: 0,
    index: null,
    total_cart_items: 0,
    loggedIn: false,
    showGallery: false,
    navbarOptions: {
      elementId: "main-navbar",
      isUsingVueRouter: true,
      mobileBreakpoint: 992,
      brandImagePath: "./",
      brandImage: "/img/logo.png",
      brandImageAltText: "brand-image",
      collapseButtonOpenColor: "#661c23",
      collapseButtonCloseColor: "#661c23",
      showBrandImageInMobilePopup: true,
      ariaLabelMainNav: "Main Navigation",
      tooltipAnimationType: "shift-away",
      tooltipPlacement: "bottom",
      menuOptionsLeft: [],
      menuOptionsRight: [
        {
          type: "button",
          text: "Panier",
          class: "my-basket",
          iconLeft:
            '<svg id="i-cart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">\n' +
            '    <path d="M6 6 L30 6 27 19 9 19 M27 23 L10 23 5 2 2 2" />\n' +
            '    <circle cx="25" cy="27" r="2" />\n' +
            '    <circle cx="12" cy="27" r="2" />\n' +
            "</svg>",
          path: { name: "ShopperCart" },
        },
        {
          type: "button",
          text: "Compte",
          class: "my-basket",
          iconLeft:
            '<svg id="i-user" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">\n' +
            '    <path d="M22 11 C22 16 19 20 16 20 13 20 10 16 10 11 10 6 12 3 16 3 20 3 22 6 22 11 Z M4 30 L28 30 C28 21 22 20 16 20 10 20 4 21 4 30 Z" />\n' +
            "</svg>",
          path: { name: "ShopperAccount" },
        },
      ],
    },
    show_hidden_data: false,
  }),
  mounted() {
    this.getProfileInfo();
    shopService.cart().then(
      function(response) {
        this.total_cart_items = response.data.items.length;
        this.navbarOptions.menuOptionsRight[0].text =
          "Panier (" + this.total_cart_items + ")";
      }.bind(this)
    );
  },
  created() {
    this.mock();
    this.getProducts();
  },
  methods: {
    slideShow(item) {
      if (item.slideCounter < item.photoSlide.length - 1) {
        item.slideCounter++;
      } else {
        item.slideCounter = 0;
      }
    },
    getProducts() {
      shopService.products().then(
        function(response) {
          this.items = response.data.map(
            function(obj) {
              obj.photo = JSON.parse(obj.photos)[0];
              obj.photoSlide = JSON.parse(obj.photos);
              obj.slideCounter = 0;
              if (obj.price > obj.promo_price && obj.promo_price > 0) {
                obj.sale =
                  100 - Math.floor((100 * obj.promo_price) / obj.price);
              }
              // return the right status
              obj.statusLabel = this.status.find((el) => {
                return el.value == obj.status;
              });
              return obj;
            }.bind(this)
          );
        }.bind(this)
      );
    },
    storeSwipe(product_id, action) {
      let redirectToDNA = false;
      if (action == "super") {
        //var loader= this.$loading.show();
        //action= 'like'
        redirectToDNA = true;
      }

      shopService
        .swipe(product_id, action)
        .then(
          function(res) {
            if (action == "like") {
              if (res.data) {
                this.$toast.success(this.$t("Toast.AddCart"));
                this.total_cart_items++;
              } else {
                this.$toast.error(this.$t("Toast.FailAddCart"));
              }
            }
            if (redirectToDNA) {
              this.$router.push("/shop/account/interests");
            }
          }.bind(this)
        )
        .finally(function() {
          // if(loader){
          //   loader.hide()
          // }
        });
    },
    mock(count = 5, append = true) {
      const list = [];
      for (let i = 0; i < count; i++) {
        list.push({ id: source[this.offset] });
        this.offset++;
      }
      if (append) {
        this.queue = this.queue.concat(list);
      } else {
        this.queue.unshift(...list);
      }
    },
    onSubmit({ type, item }) {
      this.slideCounter = 0;
      if (this.items.length == 0) {
        setTimeout(() => {
          this.getProducts();
        }, 5000);
      }
      if (this.queue.length < 3) {
        this.mock();
      }

      this.history.push(item);
      this.storeSwipe(item.id, type);
    },
    decide(choice) {
      if (choice === "super") {
        this.$refs.tinder.decide(choice);
        this.$router.push("/shop/cart");
      } else if (choice === "rewind") {
        if (this.history.length) {
          let item = this.history.pop();
          this.storeSwipe(item.id, choice);
          this.$refs.tinder.rewind([item]);
        }
      } else if (choice === "details") {
        let item = this.items[0];
        this.showGalleryEvent(item);
      } else {
        this.$refs.tinder.decide(choice);
      }
    },
    showGalleryEvent(item) {
      this.index = 0;
      this.images = JSON.parse(item.photos);
    },
    toggleHidden(id) {
      $(".hidden-" + id).slideToggle(500);
    },
    getProfileInfo() {
      shopService.getProfileInfo().then(function(res) {
        localStorage.setItem("shop_user", JSON.stringify(res.data));
      });
    },
  },
};
</script>
<style>
#Shop {
  overflow-x: hidden !important;
}
.vue-tinder {
  position: absolute;
  /* filter: brightness(85%); */
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  margin: auto;
  width: calc(100% - 20px);
  height: calc(100% - 23px - 65px - 47px - 16px);
  min-width: 300px;
  max-width: 355px;
  max-height: 650px;
}

.nope-pointer,
.like-pointer {
  position: absolute;
  z-index: 1;
  top: 20px;
  width: 64px;
  height: 64px;
}

.nope-pointer {
  right: 10px;
}

.like-pointer {
  left: 10px;
}

.super-pointer {
  position: absolute;
  z-index: 1;
  bottom: 80px;
  left: 0;
  right: 0;
  margin: auto;
  width: 64px;
  height: 64px;
}

.exclusive {
  text-transform: capitalize;
  background: linear-gradient(180deg, #23b8ff 0%, #0c88c2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-transform: uppercase;
  font-weight: 700;
  margin-top: 3px;
  margin-left: auto;
  display: flex;
  float: right;
}

.rewind-pointer {
  position: absolute;
  z-index: 1;
  top: 20px;
  right: 10px;
  width: 112px;
  height: 78px;
}

.pic {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.btns {
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  bottom: 6.5%;
  margin: auto;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 300px;
  max-width: 355px;
}

.text-price {
  text-transform: capitalize;
  background: linear-gradient(
    180deg,
    var(--primary) 0%,
    var(--primary-dark) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: 3px 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 27px;
  text-align: center;
  text-decoration: none;
  display: table;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 16px;
}

.text-price-old {
  text-transform: capitalize;
  color: #f50000;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  padding: 3px 0px 3px 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 27px;
  text-align: center;
  text-decoration: none;
  display: table;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 16px;
}

.text-status {
  background: rgba(255, 255, 255, 0.31);
  border-radius: 25px;
  border: none;
  color: #fff;
  padding: 4px 10px 3px 10px;
  text-align: center;
  text-decoration: none;
  display: table;
  margin: 4px 2px;
  cursor: pointer;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
}

.btns img {
  margin-right: 12px;
  box-shadow: 0 4px 9px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.btns img:nth-child(2n + 1) {
  width: 12%;
  max-width: 53px;
}

.btns img:nth-child(2n) {
  width: 15%;
  max-width: 65px;
}

.btns img:nth-last-child(1) {
  margin-right: 0;
}
.card-text-box {
  position: absolute;
  bottom: 0;
  padding: 10px;
  min-height: 90px;
  /* background: #00000042; */
  left: 0;
  right: 0;
  color: #fff;
}

.vgs__container {
  position: absolute;
  overflow: hidden;
  cursor: pointer;
  max-width: 100vw !important;
  margin: 0 !important;
  left: 0 !important;
  right: 0 !important;
  height: 100vh !important;
  border-radius: 0px !important;
  background-color: #000;
}

@media (max-width: 767px) {
  .vgs__container {
    top: 0 !important;
  }
}
</style>
<style lang="scss">
.vnb {
  .button-pink {
    color: #fff;
    background: #ef86c1;
    &:hover {
      background: darken(#ef86c1, 10%);
    }
  }

  .button-pink-outline {
    background: #fff;
    border: 1px solid #ef86c1;
    color: #ef86c1;
    &:hover {
      border-color: darken(#ef86c1, 10%);
      color: darken(#ef86c1, 10%);
    }
  }

  .my-basket {
    background: #fff;
    color: #ef86c1;
    &:hover {
      color: darken(#ef86c1, 10%);
    }
  }
}

.vnb__popup__bottom__menu-options__option__link:hover {
  color: #333;
  text-decoration: none;
  background: #f3f3f3;
  border-left: 2px solid #ef86c1;
}

.vnb__brand-image-wrapper__link__image {
  max-height: 40px !important;
}

.vgs__close {
  background-color: #f44336 !important;
}

.vgs__next,
.vgs__prev {
  font-size: 30px !important;
  background-color: #f44336 !important;
}

.card-text-box {
  max-height: 100%;
  overflow-y: auto;
}

.product-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  /* identical to box height */

  text-transform: uppercase;
}

.card-text-box .hidden {
  display: none;
  color: var(--secondary);
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
}

.card-text-box .hidden div {
  padding: 3px 10px;
}

.card-text-box .hidden .show-images-div {
  color: #fff;
  width: 100%;
  border: none;
  margin-bottom: 2.7vh;
}

.card-text-box .show-hidden-btn {
  width: 100px;
  color: #fff;
  margin-top: 3px;
  margin-left: auto;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  outline: none;
  background: transparent;
  padding: 5px;
  transition: 0.5s;
  border: none;
}
.card-text-box .show-hidden-btn .faIcon {
  color: #fff;
  font-size: 12px;
  margin-right: 3px;
}
.card-text-box .show-hidden-btn:hover {
  background: #55555559;
  border-radius: 15px;
}

.tag {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(108, 247, 138, 0.27);
  border-radius: 25px;
  color: #ffffff;
  padding: 3px 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  font-family: "Inter";
  text-transform: capitalize;
}

.button-pink {
  color: #fff;
  background: #ef86c1;
  padding: 5px 0;
  border-radius: 7px;
  &:hover {
    background: darken(#ef86c1, 10%);
  }
}

.slider {
  top: 1%;
  position: absolute;
  left: 5%;
  display: flex;
}

.info-step {
  width: 24px;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  margin: 5px 3px;
  border-radius: 20px;
}

.info-step-active {
  width: 24px;
  height: 4px;
  background: rgba(255, 255, 255, 0.8);
  margin: 5px 3px;
  border-radius: 20px;
}

.slide-show {
  width: 100%;
  height: 70%;
  padding-top: 40px;
}

.filter-image {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(9, 9, 9, 0.137) 0%,
    rgba(9, 9, 9, 0.418) 70.12%
  );
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
}
</style>
